// src/auth/tokenStorage.js
// Единая точка чтения/записи токенов. Ключи можно поменять при необходимости.
const ACCESS_KEY = 'token';
const REFRESH_KEY = 'refresh';

let memCache = {
  access: null,
  refresh: null,
};

/**
 * Инициализация из localStorage (лениво, один раз)
 */
function ensureLoaded() {
  if (memCache.access === null && typeof window !== 'undefined') {
    memCache.access = localStorage.getItem(ACCESS_KEY) || '';
    memCache.refresh = localStorage.getItem(REFRESH_KEY) || '';
  }
}

export function getAccess() {
  ensureLoaded();
  return memCache.access || '';
}

export function getRefresh() {
  ensureLoaded();
  return memCache.refresh || '';
}

export function setTokens({ access, refresh }) {
  if (typeof access === 'string' && access) {
    memCache.access = access;
    localStorage.setItem(ACCESS_KEY, access);
  }
  // refresh может ротироваться или отсутствовать (зависит от настроек сервера)
  if (typeof refresh === 'string' && refresh) {
    memCache.refresh = refresh;
    localStorage.setItem(REFRESH_KEY, refresh);
  }
}

export function clearTokens() {
  memCache.access = '';
  memCache.refresh = '';
  try {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  } catch (_) {}
}
